module.exports = __webpack_public_path__ + "static/media/dashboard.18e464aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/agency/assets/dashboard.png
// module id = 228
// module chunks = 0